import { getAllResultsPreloadStateQueryKey, resolveSearchThreadQueryMode, } from '#pplx/frontend/apps/ask/all-results/hooks/allResultsQuery.js';
import { ASI_SUPPORTED_BLOCK_USE_CASES, BASE_SUPPORTED_BLOCK_USE_CASES, } from '#pplx/frontend/components/utils/consts.js';
export function resolveThreadEntriesQueryMode(surface, locationHash = '') {
    // Computer always opens at the latest page (useComputerThreadEntriesSource defaults).
    return surface === 'search'
        ? resolveSearchThreadQueryMode(locationHash)
        : { paginationEnabled: true, paginateFromLatest: true };
}
// Keyed like the route's own query, and records the preload-state entry the
// route reads to attribute its timing to the preload.
export function buildThreadEntriesPreloadParams({ queryClient, allowPersist, slugOrUUID, surface, locationHash = '', reason, lifecycle, }) {
    const queryMode = resolveThreadEntriesQueryMode(surface, locationHash);
    const preloadStateQueryKey = getAllResultsPreloadStateQueryKey(slugOrUUID, queryMode.paginationEnabled, queryMode.paginateFromLatest);
    const startedAt = performance.now();
    return {
        queryClient,
        allowPersist,
        slugOrUUID,
        ...queryMode,
        supportedBlockUseCases: surface === 'computer' ? ASI_SUPPORTED_BLOCK_USE_CASES : BASE_SUPPORTED_BLOCK_USE_CASES,
        reason,
        isSidecar: false,
        lifecycle: {
            ...lifecycle,
            onFirstPageResponse: (success) => {
                if (success) {
                    queryClient.setQueryData(preloadStateQueryKey, {
                        startedAt,
                        resolvedAt: performance.now(),
                    });
                }
                lifecycle?.onFirstPageResponse?.(success);
            },
        },
    };
}
//# sourceMappingURL=threadEntriesPreload.js.map